import { z } from 'zod'

/**
 * Where a review of a vendor company stands (docs/vendor-growth.spec.md,
 * "Reviews"). Mirrors the Prisma `VendorReviewStatus` enum (`check:enums`).
 *
 * - `pending`: waiting for a platform admin; its writer may still change it.
 * - `approved`: published, and fixed from then on.
 * - `declined`: an admin said no, with a reason its writer sees; it may be
 *   changed and sent again.
 * - `removed`: taken down after the vendor reported it; it never shows again.
 */
export const VENDOR_REVIEW_STATUSES = ['pending', 'approved', 'declined', 'removed'] as const

export const vendorReviewStatusSchema = z.enum(VENDOR_REVIEW_STATUSES)

export type VendorReviewStatus = z.infer<typeof vendorReviewStatusSchema>

/** Still the writer's to change and send again: waiting, or declined. An approved or removed review is fixed. */
export const RESENDABLE_VENDOR_REVIEW_STATUSES = ['pending', 'declined'] as const satisfies readonly VendorReviewStatus[]
